// eslint-disable-next-line no-unused-vars
import $ from 'jquery';
import AnchorJS from 'anchor-js';
import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/scrollspy';
import renderTemplate from './util/template';
import svgCardTemplate from './_docs/views/svg-sample-card.tpl.html';
import initNav from './_docs/toc';
import loadSampleApp from './_docs/loadapp';
import config from './util/config';
import { setExternalLinkChecker, isExternal } from './links';
import loadFrontend, { initFrontend } from './index';

var sample = function sample(arr) {
  return arr[Math.floor(Math.random() * arr.length)];
};

var loadSVGSprites = function loadSVGSprites() {
  var svgSprites = [{
    color: function color() {
      return sample(['digital-green', 'digital-blue', 'cigna-orange-dark']);
    },
    name: 'icon-sprite.svg',
    path: "".concat(config.svgPath, "icon-sprite.svg"),
    size: '5rem'
  }, {
    color: function color() {
      return 'gray-60';
    },
    name: 'component-sprite.svg',
    path: "".concat(config.svgPath, "component-sprite.svg"),
    size: '2rem'
  }, {
    color: function color() {
      return 'brand';
    },
    name: 'brand-sprite.svg',
    path: "".concat(config.svgPath, "brand-sprite.svg"),
    size: '5rem'
  }, {
    color: function color() {
      return 'co-logos';
    },
    name: 'co-logos-sprite.svg',
    path: "".concat(config.svgPath, "co-logos-sprite.svg"),
    size: '5rem'
  }, {
    color: function color() {
      return sample(['digital-green', 'digital-blue', 'cigna-orange-dark']);
    },
    name: 'corp-responsibility-sprite.svg',
    path: "".concat(config.svgPath, "corp-responsibility-sprite.svg"),
    size: '5rem'
  }];
  var promises = [];

  if (location.pathname.endsWith('icons.html') || location.pathname.endsWith('icons')) {
    svgSprites.forEach(function (svgSprite) {
      var promise = Promise.resolve($.get(svgSprite.path));
      promise.then(function (data) {
        var symbols = $('symbol', data).toArray();

        if (symbols.length) {
          var html = renderTemplate(svgCardTemplate, {
            svgSprite: svgSprite,
            symbols: symbols
          });
          $('.icon-sprite-list').append(html);
        }
      });
      promises.push(promise);
    });
  }

  return promises;
};

var initDocs = function initDocs() {
  var promises = loadSVGSprites();
  Promise.all(promises).then(function () {
    // add anchor links to headings
    var anchors = new AnchorJS();
    anchors.options = {
      icon: '#'
    };
    anchors.add('.docs-content > h2:not([data-toc-skip]), .docs-content > h3:not([data-toc-skip]), .docs-content > h4:not([data-toc-skip]), .docs-content > h5:not([data-toc-skip]), .docs-content h2[data-toc-links], .docs-content h3[data-toc-links], .docs-content h4[data-toc-links], .docs-content h5[data-toc-links]');
    $('.docs-content > h2:not([data-toc-skip]), .docs-content > h3:not([data-toc-skip]), .docs-content > h4:not([data-toc-skip]), .docs-content > h5:not([data-toc-skip], .docs-content h2[data-toc-links], .docs-content h3[data-toc-links], .docs-content h4[data-toc-links], .docs-content h5[data-toc-links])').wrapInner('<div></div>'); // add table of contents from headings

    $('nav[data-toggle="toc"]').each(function (i, el) {
      var $nav = $(el);
      initNav($nav);
    }); // enable scrollspy for toc

    $('body').scrollspy({
      target: '#toc',
      offset: $('.docs-navbar').outerHeight()
    });
    loadSampleApp();
  });
};

var isExternalLink = function isExternalLink(link, href, hostname) {
  var isExternalDefault = isExternal(link, href, hostname);

  if (href.includes('/medicare/') && $.trim(link.text()).length) {
    return true;
  }

  return isExternalDefault && !hostname.includes('.cigna.com'); // not a cigna.com host
};

$(function () {
  var init = function init(err) {
    setExternalLinkChecker(isExternalLink);
    initFrontend(err);
    initDocs();
  };

  loadFrontend(init);
});